import React from 'react';
import './Layout.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {year} D&D Map Explorer - Alpha Version</p>
      </div>
    </footer>
  );
};

export default Footer;